/**
 * Нейросети для фотореалистичной визуализации. Здесь — только то, что видит
 * пользователь; как вызывать каждую модель у провайдера, знает API
 * (apps/api/src/modules/renders/kie-provider.ts).
 *
 * Модели заметно отличаются по манере: одна точнее держит планировку, другая
 * богаче дорисовывает материалы. Поэтому выбор оставлен прорабу, а в галерее
 * у каждой картинки видно, какой моделью она сделана, — варианты удобно сравнить.
 */
export const RENDER_MODELS = [
    {
        code: 'nano-banana',
        label: 'Nano Banana',
        note: 'Google. Быстрая, аккуратно сохраняет окна и двери',
    },
    {
        code: 'nano-banana-2',
        label: 'Nano Banana 2',
        note: 'Google. Новее и детальнее, 2K',
    },
    {
        code: 'nano-banana-pro',
        label: 'Nano Banana Pro',
        note: 'Google. Лучше всех следует пожеланиям, 2K',
    },
    {
        code: 'seedream-4.5',
        label: 'Seedream 4.5',
        note: 'ByteDance. Сочные «журнальные» интерьеры, 2K',
    },
    {
        code: 'seedream-5-pro',
        label: 'Seedream 5 Pro',
        note: 'ByteDance. Новейшая версия, 2K',
    },
    {
        code: 'flux-2-pro',
        label: 'Flux 2 Pro',
        note: 'Black Forest Labs. Естественный свет и фактуры, 2K',
    },
    {
        code: 'gpt-image-2',
        label: 'GPT Image 2',
        note: 'OpenAI. Понимает сложные пожелания, работает дольше',
    },
];
export const RENDER_MODEL_CODES = RENDER_MODELS.map((m) => m.code);
/**
 * Пожелания заказчика — не длиннее. Прорабы пишут подробное ТЗ на дизайн
 * (цвета, свет, проводка, шторы) — это 1,5–2 тыс. символов, а лимит самой
 * нейросети — на весь запрос вместе с нашей служебной частью (~1300 символов).
 */
export const RENDER_WISHES_MAX_LENGTH = 3000;
/**
 * Модели с лимитом запроса строже общего: Seedream 4.5 принимает только
 * 3000 символов на весь запрос (у остальных — 5–20 тыс.).
 */
const WISHES_MAX_BY_MODEL = {
    'seedream-4.5': 1700,
};
export function renderWishesMaxLength(model) {
    return WISHES_MAX_BY_MODEL[model] ?? RENDER_WISHES_MAX_LENGTH;
}
/** Модель, которой генерировали до появления выбора, — поведение по умолчанию не меняется. */
export const DEFAULT_RENDER_MODEL = 'nano-banana';
//# sourceMappingURL=render-models.js.map